import React from 'react';
import { Button, Card, Typography } from '@lamimed/pantheon';
import Image from 'next/legacy/image';
import { useRouter } from 'next/router';

import { Category } from 'models/Category';

import * as S from './styles';

interface NoProductsProps {
  category?: Category;
}

export const NoProducts: React.FC<NoProductsProps> = ({ category }) => {
  const router = useRouter();
  const categoryTitle = category?.title ? `"${category.title}"` : '';

  return (
    <S.NoProductsContainer>
      <Card variant="default" color="neutral_extra_light" isExpanded>
        <Card.Header
          size="medium"
          variant="default"
          colors="neutral_extra_light"
        >
          <S.ContainerCentering>
            <Image
              alt="not-found"
              src="/images/not-found.svg"
              width={38}
              height={48}
            />

            <Typography
              variant="heading_4"
              color="text__primary"
              textAlign="center"
            >
              Non siamo ancora presenti con il servizio {categoryTitle} in
              questa città
            </Typography>

            <S.TextContainer>
              <Typography
                variant="body_text_1"
                color="text__primary"
                textAlign="center"
              >
                Ci stiamo lavorando!
              </Typography>
            </S.TextContainer>

            <Button
              variant="default"
              color="primary"
              onClick={() => router.push('/')}
              extended={false}
            >
              Home
            </Button>
          </S.ContainerCentering>
        </Card.Header>
      </Card>
    </S.NoProductsContainer>
  );
};
